/**
 * Pasos para exportar un crucigrama
 * 1. Generar el crucigrama en https://www.educima.com/crosswordgenerator.php
 * 2. En la página que se abre, copiar del DOM el elemento con id="crossword"
 * 3. Eliminar las etiquetas <table>, <tbody>
 * 4. Sustitutir las etiquetas <td> y <div> por <div>
 * 5. Sustituir las clases 'grid-square' por 'square' y 'crossword-row' por 'row'
 * 6. Reemplazar en el elemento los siguientes atributos
 * 6.1 Reemplazar 'class' por 'className'
 * 6.1 Reemplazar disabled="" por vacio
 * 6.2 Ajustar el 'style' en react 'style={{ textAlign: 'center' }}'
 * 6.3 Reemplazar 'maxLength={1}' por 'maxLength={1} onKeyDown={handleOnKeyDown}'
 */

import { handleOnKeyDown } from 'utils/crosswords.utils';

export const Crossword14 = (
    <div className="center crossword" id="crossword" style={{ textAlign: 'center' }}>
        <tr className="row">
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
        </tr>
        <tr className="row">
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square">
                <input className="char" maxLength={1} onKeyDown={handleOnKeyDown} data-letter="S" data-num="6" placeholder="" data-across="6" />
                <span className="num">1</span>
            </div>
            <div className="square">
                <input className="char" maxLength={1} onKeyDown={handleOnKeyDown} data-letter="P" data-num="6" placeholder="" data-across="6" />
                <span className="num"></span>
            </div>
            <div className="square">
                <input className="char" maxLength={1} onKeyDown={handleOnKeyDown} data-letter="A" data-num="6" placeholder="" data-across="6" data-down="0" />
                <span className="num">2</span>
            </div>
            <div className="square">
                <input className="char" maxLength={1} onKeyDown={handleOnKeyDown} data-letter="C" data-num="6" placeholder="" data-across="6" />
                <span className="num"></span>
            </div>
            <div className="square">
                <input className="char" maxLength={1} onKeyDown={handleOnKeyDown} data-letter="E" data-num="6" placeholder="" data-across="6" />
                <span className="num"></span>
            </div>
            <div className="square">
                <input className="char" maxLength={1} onKeyDown={handleOnKeyDown} data-letter="X" data-num="6" placeholder="" data-across="6" />
                <span className="num"></span>
            </div>
            <div className="square"></div>
        </tr>
        <tr className="row">
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square">
                <input className="char" maxLength={1} onKeyDown={handleOnKeyDown} data-letter="U" data-num="0" placeholder="" data-down="0" />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
        </tr>
        <tr className="row">
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square">
                <input className="char" maxLength={1} onKeyDown={handleOnKeyDown} data-letter="T" data-num="0" placeholder="" data-down="0" />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square">
                <input className="char" maxLength={1} onKeyDown={handleOnKeyDown} data-letter="W" data-num="7" placeholder="" data-down="7" />
                <span className="num">3</span>
            </div>
            <div className="square"></div>
        </tr>
        <tr className="row">
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square">
                <input className="char" maxLength={1} onKeyDown={handleOnKeyDown} data-letter="B" data-num="2" placeholder="" data-across="2" />
                <span className="num">4</span>
            </div>
            <div className="square">
                <input className="char" maxLength={1} onKeyDown={handleOnKeyDown} data-letter="O" data-num="2" placeholder="" data-across="2" data-down="0" />
                <span className="num"></span>
            </div>
            <div className="square">
                <input className="char" maxLength={1} onKeyDown={handleOnKeyDown} data-letter="G" data-num="2" placeholder="" data-across="2" />
                <span className="num"></span>
            </div>
            <div className="square">
                <input className="char" maxLength={1} onKeyDown={handleOnKeyDown} data-letter="L" data-num="2" placeholder="" data-across="2" />
                <span className="num"></span>
            </div>
            <div className="square">
                <input className="char" maxLength={1} onKeyDown={handleOnKeyDown} data-letter="E" data-num="7" placeholder="" data-across="2" data-down="7" />
                <span className="num"></span>
            </div>
            <div className="square"></div>
        </tr>
        <tr className="row">
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square">
                <input className="char" maxLength={1} onKeyDown={handleOnKeyDown} data-letter="M" data-num="0" placeholder="" data-down="0" />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square">
                <input className="char" maxLength={1} onKeyDown={handleOnKeyDown} data-letter="B" data-num="7" placeholder="" data-down="7" />
                <span className="num"></span>
            </div>
            <div className="square"></div>
        </tr>
        <tr className="row">
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square">
                <input className="char" maxLength={1} onKeyDown={handleOnKeyDown} data-letter="A" data-num="0" placeholder="" data-down="0" />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square">
                <input className="char" maxLength={1} onKeyDown={handleOnKeyDown} data-letter="I" data-num="7" placeholder="" data-down="7" />
                <span className="num"></span>
            </div>
            <div className="square"></div>
        </tr>
        <tr className="row">
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square">
                <input className="char" maxLength={1} onKeyDown={handleOnKeyDown} data-letter="D" data-num="3" placeholder="" data-down="3" />
                <span className="num">5</span>
            </div>
            <div className="square"></div>
            <div className="square">
                <input className="char" maxLength={1} onKeyDown={handleOnKeyDown} data-letter="T" data-num="0" placeholder="" data-down="0" />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square">
                <input className="char" maxLength={1} onKeyDown={handleOnKeyDown} data-letter="N" data-num="7" placeholder="" data-down="7" />
                <span className="num"></span>
            </div>
            <div className="square"></div>
        </tr>
        <tr className="row">
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square">
                <input className="char" maxLength={1} onKeyDown={handleOnKeyDown} data-letter="M" data-num="1" placeholder="" data-across="1" />
                <span className="num">6</span>
            </div>
            <div className="square">
                <input className="char" maxLength={1} onKeyDown={handleOnKeyDown} data-letter="I" data-num="3" placeholder="" data-across="1" data-down="3" />
                <span className="num"></span>
            </div>
            <div className="square">
                <input className="char" maxLength={1} onKeyDown={handleOnKeyDown} data-letter="F" data-num="1" placeholder="" data-across="1" />
                <span className="num"></span>
            </div>
            <div className="square">
                <input className="char" maxLength={1} onKeyDown={handleOnKeyDown} data-letter="I" data-num="1" placeholder="" data-across="1" data-down="0" />
                <span className="num"></span>
            </div>
            <div className="square">
                <input className="char" maxLength={1} onKeyDown={handleOnKeyDown} data-letter="D" data-num="1" placeholder="" data-across="1" />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square">
                <input className="char" maxLength={1} onKeyDown={handleOnKeyDown} data-letter="A" data-num="7" placeholder="" data-down="7" />
                <span className="num"></span>
            </div>
            <div className="square"></div>
        </tr>
        <tr className="row">
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square">
                <input className="char" maxLength={1} onKeyDown={handleOnKeyDown} data-letter="V" data-num="3" placeholder="" data-down="3" />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square">
                <input className="char" maxLength={1} onKeyDown={handleOnKeyDown} data-letter="Z" data-num="0" placeholder="" data-down="0" />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square">
                <input className="char" maxLength={1} onKeyDown={handleOnKeyDown} data-letter="R" data-num="7" placeholder="" data-down="7" />
                <span className="num"></span>
            </div>
            <div className="square"></div>
        </tr>
        <tr className="row">
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square">
                <input className="char" maxLength={1} onKeyDown={handleOnKeyDown} data-letter="I" data-num="3" placeholder="" data-down="3" />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square">
                <input className="char" maxLength={1} onKeyDown={handleOnKeyDown} data-letter="A" data-num="0" placeholder="" data-down="0" />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
        </tr>
        <tr className="row">
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square">
                <input className="char" maxLength={1} onKeyDown={handleOnKeyDown} data-letter="D" data-num="3" placeholder="" data-down="3" />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square">
                <input className="char" maxLength={1} onKeyDown={handleOnKeyDown} data-letter="D" data-num="0" placeholder="" data-down="0" />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
        </tr>
        <tr className="row">
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square">
                <input className="char" maxLength={1} onKeyDown={handleOnKeyDown} data-letter="E" data-num="3" placeholder="" data-down="3" />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square">
                <input className="char" maxLength={1} onKeyDown={handleOnKeyDown} data-letter="A" data-num="0" placeholder="" data-down="0" />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
        </tr>
        <tr className="row">
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square">
                <input className="char" maxLength={1} onKeyDown={handleOnKeyDown} data-letter="C" data-num="4" placeholder="" data-across="4" />
                <span className="num">7</span>
            </div>
            <div className="square">
                <input className="char" maxLength={1} onKeyDown={handleOnKeyDown} data-letter="O" data-num="4" placeholder="" data-across="4" />
                <span className="num"></span>
            </div>
            <div className="square">
                <input className="char" maxLength={1} onKeyDown={handleOnKeyDown} data-letter="L" data-num="4" placeholder="" data-across="4" />
                <span className="num"></span>
            </div>
            <div className="square">
                <input className="char" maxLength={1} onKeyDown={handleOnKeyDown} data-letter="C" data-num="4" placeholder="" data-across="4" />
                <span className="num"></span>
            </div>
            <div className="square">
                <input className="char" maxLength={1} onKeyDown={handleOnKeyDown} data-letter="H" data-num="4" placeholder="" data-across="4" />
                <span className="num"></span>
            </div>
            <div className="square">
                <input className="char" maxLength={1} onKeyDown={handleOnKeyDown} data-letter="Ó" data-num="4" placeholder="" data-across="4" />
                <span className="num"></span>
            </div>
            <div className="square">
                <input className="char" maxLength={1} onKeyDown={handleOnKeyDown} data-letter="N" data-num="4" placeholder="" data-across="4" data-down="3" />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
        </tr>
        <tr className="row">
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square">
                <input className="char" maxLength={1} onKeyDown={handleOnKeyDown} data-letter="D" data-num="3" placeholder="" data-down="3" />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
        </tr>
        <tr className="row">
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square">
                <input className="char" maxLength={1} onKeyDown={handleOnKeyDown} data-letter="D" data-num="5" placeholder="" data-across="5" />
                <span className="num">8</span>
            </div>
            <div className="square">
                <input className="char" maxLength={1} onKeyDown={handleOnKeyDown} data-letter="E" data-num="5" placeholder="" data-across="5" />
                <span className="num"></span>
            </div>
            <div className="square">
                <input className="char" maxLength={1} onKeyDown={handleOnKeyDown} data-letter="P" data-num="5" placeholder="" data-across="5" />
                <span className="num"></span>
            </div>
            <div className="square">
                <input className="char" maxLength={1} onKeyDown={handleOnKeyDown} data-letter="Ó" data-num="5" placeholder="" data-across="5" />
                <span className="num"></span>
            </div>
            <div className="square">
                <input className="char" maxLength={1} onKeyDown={handleOnKeyDown} data-letter="S" data-num="5" placeholder="" data-across="5" />
                <span className="num"></span>
            </div>
            <div className="square">
                <input className="char" maxLength={1} onKeyDown={handleOnKeyDown} data-letter="I" data-num="5" placeholder="" data-across="5" />
                <span className="num"></span>
            </div>
            <div className="square">
                <input className="char" maxLength={1} onKeyDown={handleOnKeyDown} data-letter="T" data-num="8" placeholder="" data-across="5" data-down="8" />
                <span className="num">9</span>
            </div>
            <div className="square">
                <input className="char" maxLength={1} onKeyDown={handleOnKeyDown} data-letter="O" data-num="5" placeholder="" data-across="5" data-down="3" />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
        </tr>
        <tr className="row">
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square">
                <input className="char" maxLength={1} onKeyDown={handleOnKeyDown} data-letter="U" data-num="8" placeholder="" data-down="8" />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
        </tr>
        <tr className="row">
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square">
                <input className="char" maxLength={1} onKeyDown={handleOnKeyDown} data-letter="M" data-num="8" placeholder="" data-down="8" />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
        </tr>
        <tr className="row">
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square">
                <input className="char" maxLength={1} onKeyDown={handleOnKeyDown} data-letter="B" data-num="8" placeholder="" data-down="8" />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
        </tr>
        <tr className="row">
            <div className="square"></div>
            <div className="square"></div>
            <div className="square">
                <input className="char" maxLength={1} onKeyDown={handleOnKeyDown} data-letter="S" data-num="13" placeholder="" data-down="13" />
                <span className="num">10</span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square">
                <input className="char" maxLength={1} onKeyDown={handleOnKeyDown} data-letter="O" data-num="8" placeholder="" data-down="8" />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square">
                <input className="char" maxLength={1} onKeyDown={handleOnKeyDown} data-letter="X" data-num="10" placeholder="" data-down="10" />
                <span className="num">11</span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
        </tr>
        <tr className="row">
            <div className="square"></div>
            <div className="square"></div>
            <div className="square">
                <input className="char" maxLength={1} onKeyDown={handleOnKeyDown} data-letter="U" data-num="13" placeholder="" data-down="13" />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square">
                <input className="char" maxLength={1} onKeyDown={handleOnKeyDown} data-letter="N" data-num="8" placeholder="" data-down="8" />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square">
                <input className="char" maxLength={1} onKeyDown={handleOnKeyDown} data-letter="E" data-num="10" placeholder="" data-down="10" />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
        </tr>
        <tr className="row">
            <div className="square"></div>
            <div className="square"></div>
            <div className="square">
                <input className="char" maxLength={1} onKeyDown={handleOnKeyDown} data-letter="B" data-num="13" placeholder="" data-down="13" />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square">
                <input className="char" maxLength={1} onKeyDown={handleOnKeyDown} data-letter="C" data-num="11" placeholder="" data-across="9" data-down="11" />
                <span className="num">12</span>
            </div>
            <div className="square">
                <input className="char" maxLength={1} onKeyDown={handleOnKeyDown} data-letter="H" data-num="9" placeholder="" data-across="9" />
                <span className="num"></span>
            </div>
            <div className="square">
                <input className="char" maxLength={1} onKeyDown={handleOnKeyDown} data-letter="A" data-num="9" placeholder="" data-across="9" data-down="8" />
                <span className="num"></span>
            </div>
            <div className="square">
                <input className="char" maxLength={1} onKeyDown={handleOnKeyDown} data-letter="T" data-num="9" placeholder="" data-across="9" />
                <span className="num"></span>
            </div>
            <div className="square">
                <input className="char" maxLength={1} onKeyDown={handleOnKeyDown} data-letter="G" data-num="9" placeholder="" data-across="9" />
                <span className="num"></span>
            </div>
            <div className="square">
                <input className="char" maxLength={1} onKeyDown={handleOnKeyDown} data-letter="P" data-num="9" placeholder="" data-across="9" />
                <span className="num"></span>
            </div>
            <div className="square">
                <input className="char" maxLength={1} onKeyDown={handleOnKeyDown} data-letter="T" data-num="10" placeholder="" data-across="9" data-down="10" />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
        </tr>
        <tr className="row">
            <div className="square"></div>
            <div className="square">
                <input className="char" maxLength={1} onKeyDown={handleOnKeyDown} data-letter="T" data-num="12" placeholder="" data-across="12" />
                <span className="num">14</span>
            </div>
            <div className="square">
                <input className="char" maxLength={1} onKeyDown={handleOnKeyDown} data-letter="R" data-num="13" placeholder="" data-across="12" data-down="13" />
                <span className="num"></span>
            </div>
            <div className="square">
                <input className="char" maxLength={1} onKeyDown={handleOnKeyDown} data-letter="A" data-num="12" placeholder="" data-across="12" />
                <span className="num"></span>
            </div>
            <div className="square">
                <input className="char" maxLength={1} onKeyDown={handleOnKeyDown} data-letter="S" data-num="12" placeholder="" data-across="12" />
                <span className="num"></span>
            </div>
            <div className="square">
                <input className="char" maxLength={1} onKeyDown={handleOnKeyDown} data-letter="P" data-num="12" placeholder="" data-across="12" />
                <span className="num"></span>
            </div>
            <div className="square">
                <input className="char" maxLength={1} onKeyDown={handleOnKeyDown} data-letter="A" data-num="12" placeholder="" data-across="12" />
                <span className="num"></span>
            </div>
            <div className="square">
                <input className="char" maxLength={1} onKeyDown={handleOnKeyDown} data-letter="S" data-num="12" placeholder="" data-across="12" />
                <span className="num"></span>
            </div>
            <div className="square">
                <input className="char" maxLength={1} onKeyDown={handleOnKeyDown} data-letter="O" data-num="12" placeholder="" data-across="12" data-down="11" />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square">
                <input className="char" maxLength={1} onKeyDown={handleOnKeyDown} data-letter="R" data-num="10" placeholder="" data-down="10" />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
        </tr>
        <tr className="row">
            <div className="square"></div>
            <div className="square"></div>
            <div className="square">
                <input className="char" maxLength={1} onKeyDown={handleOnKeyDown} data-letter="O" data-num="13" placeholder="" data-down="13" />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square">
                <input className="char" maxLength={1} onKeyDown={handleOnKeyDown} data-letter="R" data-num="11" placeholder="" data-down="11" />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square">
                <input className="char" maxLength={1} onKeyDown={handleOnKeyDown} data-letter="A" data-num="10" placeholder="" data-down="10" />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
        </tr>
        <tr className="row">
            <div className="square"></div>
            <div className="square"></div>
            <div className="square">
                <input className="char" maxLength={1} onKeyDown={handleOnKeyDown} data-letter="G" data-num="13" placeholder="" data-down="13" />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square">
                <input className="char" maxLength={1} onKeyDown={handleOnKeyDown} data-letter="N" data-num="11" placeholder="" data-down="11" />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
        </tr>
        <tr className="row">
            <div className="square"></div>
            <div className="square"></div>
            <div className="square">
                <input className="char" maxLength={1} onKeyDown={handleOnKeyDown} data-letter="A" data-num="13" placeholder="" data-down="13" />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square">
                <input className="char" maxLength={1} onKeyDown={handleOnKeyDown} data-letter="E" data-num="11" placeholder="" data-down="11" />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
        </tr>
        <tr className="row">
            <div className="square"></div>
            <div className="square"></div>
            <div className="square">
                <input className="char" maxLength={1} onKeyDown={handleOnKeyDown} data-letter="R" data-num="13" placeholder="" data-down="13" />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square">
                <input className="char" maxLength={1} onKeyDown={handleOnKeyDown} data-letter="L" data-num="11" placeholder="" data-down="11" />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
        </tr>
        <tr className="row">
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square">
                <input className="char" maxLength={1} onKeyDown={handleOnKeyDown} data-letter="L" data-num="11" placeholder="" data-down="11" />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
        </tr>
        <tr className="row">
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square">
                <input className="char" maxLength={1} onKeyDown={handleOnKeyDown} data-letter="A" data-num="11" placeholder="" data-down="11" />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
        </tr>
        <tr className="row">
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
        </tr>
    </div>
);
